<nav class="navbar">
  <!-- Right side - Search features -->
  <div class="navbar-right">
    <!-- Search input -->
    <div class="search-input">
      <input
        type="text"
        placeholder="phone number or fbLeadReference"
        [(ngModel)]="phoneNumberSearchQuery"
        (keyup.enter)="onSearch()"
        [disabled]="disabledSearch"
        class="custom-placeholder"
      />
      <button class="search-button" (click)="onSearch()" [disabled]="disabledSearch">Search</button>
    </div>
  </div>

  <!-- Right side - User related features -->
  <div class="navbar-left">
    <!-- User name -->
    <!-- <div class="user-name">
      <span><i class="fas fa-user" style="margin-right :10px; font-size: 20px;"></i> Agent</span>
    </div> -->
    <div class="user-name">
      <span>
        <i class="fas fa-user" style="margin-right: 10px; font-size: 20px;"></i>
        {{ userLogin ? userLogin : 'Agent' }}
      </span>
    </div>
    <!-- Login/Logout button -->
    <div class="login-logout">
      <button (click)="logout()">Logout</button>
    </div>
  </div>
</nav>
